const MAIN_CLASS = 'component-loader-container';
const HIDDEN_CLASS = 'component-loader-container--hidden';
const CHILD_CLASS = 'component-loader-dot';
const CONTAINER_ATTRIBUTE = 'data-component-loader-container';

export default {
	bind(el) {
		let position = window.getComputedStyle(el).position;

		if (position === 'static' || position === '') {
			el.style.position = 'relative';
		}

		let layer = document.createElement('div');
		layer.setAttribute(CONTAINER_ATTRIBUTE, '');
		layer.className = `${MAIN_CLASS} ${HIDDEN_CLASS}`;

		for (let i = 0; i < 5; i++) {
			let dot = document.createElement('div');
			dot.className = CHILD_CLASS;
			layer.appendChild(dot);
		}

		el.appendChild(layer);
	},
	update(el, binding, vnode) {
		if (vnode.context[binding.expression]) {
			for (const element of el.children) {
				element.attributes.getNamedItem(CONTAINER_ATTRIBUTE) ?
					element.classList.remove(HIDDEN_CLASS) :
					element.classList.add(HIDDEN_CLASS);
			}
		} else {
			for (const element of el.children) {
				element.attributes.getNamedItem(CONTAINER_ATTRIBUTE) ?
					element.classList.add(HIDDEN_CLASS) :
					element.classList.remove(HIDDEN_CLASS);
			}
		}
	}
};



// WEBPACK FOOTER //
// ../source/common/component-loader/component-loader.js